import template from './template.html';
import {includes, remove} from 'lodash';

export default {
    name: 'accordion',
    template: template,
    props: {
        fields: Array,
        multiple_prop: false,
        active_prop: Array,
    },
    data() {
        return {
            active: this.active_prop,
            multiple: this.multiple_prop
        };
    },
    methods: {
        isActive(index) {
            return includes(this.active, index);
        },
        addActiveItem(index) {
            if(this.multiple) {
                this.active.push(index);
            } else {
                this.$set(this, 'active', [index]);
            }
        },
        triggerItem(index) {
            if(this.isActive(index)) {
                this.$set(this, 'active', remove(this.active, (v) => v !== index));
            } else {
                this.addActiveItem(index);
            }
        }
    }
};